import React from 'react';
import { Grid, Typography } from '@mui/material';
import Card from '../common/Card';

const NumberItem = ({ label, value }) => (
  <Card>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
    <Typography variant="h6" sx={{ mt: 0.5 }}>{value}</Typography>
  </Card>
);

const EngineSummaryCards = ({ summary }) => {
  const safeSummary = summary || {};

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <NumberItem label="Total Positions" value={Number(safeSummary.total || 0)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <NumberItem label="Long Exposure" value={Number(safeSummary.longExposure || 0).toFixed(2)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <NumberItem label="Short Exposure" value={Number(safeSummary.shortExposure || 0).toFixed(2)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <NumberItem label="Total PnL" value={Number(safeSummary.totalPnl || 0).toFixed(2)} />
      </Grid>
    </Grid>
  );
};

export default EngineSummaryCards;
